import { unflatten } from 'flat';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import ApiClient from 'ApiClient';

const Inactive = ({ record }) => {
  const key = 'inactive';

  const aValues = { Yes: 'Yes', No: 'No' };

  const recordUnflatten = unflatten(record);
  const rowData = recordUnflatten.params;
  const val = (typeof rowData !== 'undefined' && typeof rowData[key] !== 'undefined') ? rowData[key] : 'No';
  const [value, setValue] = useState(val);
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(null);
  const options = Object.keys(aValues).map(k => ({ value: k, label: aValues[k] }));
  useEffect(() => {
    setValue(val);
  }, [rowData._id]);
  const handleChange = async (option) => {
    setDisabled(true);
    setError(null);
    setValue(option.value);
    const data = new FormData();
    data.append(key, option.value);
    const api = new ApiClient();
    try {
      await api.recordAction({
        resourceId: 'Advertiser',
        recordId: record.id,
        actionName: 'edit',
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // updateRecordFunction(record.id, { paymentStatus: option.value });
    } catch (e) {
      setError(e.message);
      setDisabled(false);
    }
    setDisabled(false);
    return true;
  };
  return (
    <div style={{ minWidth: '100px', maxWidth: '100px' }} >
      <Select
        value={options.filter(option => option.value === value)}
        options={options}
        onChange={handleChange}
        placeholder="Inactive?"
        isDisabled={disabled}
        menuPlacement="auto"
        menuPortalTarget={document.body}
      />
      {error ? (<span className="text-danger">{error}</span>) : null}
    </div>
  );
};

Inactive.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
  // updateRecordFunction: PropTypes.func.isRequired,
};
export default Inactive;
